import { render, staticRenderFns } from "./HygicultAdmin.vue?vue&type=template&id=b212619a&"
import script from "./HygicultAdmin.vue?vue&type=script&lang=js&"
export * from "./HygicultAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports